import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-reports-home',
  templateUrl: './reports-home.component.html',
  styleUrls: ['./reports-home.component.scss'],
})
export class ReportsHomeComponent {
  // Component logic goes here
}